import { render } from "./SixthStar.vue?vue&type=template&id=5ff7b4a1"
import script from "./SixthStar.vue?vue&type=script&lang=js"
export * from "./SixthStar.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__